import {Directive, ElementRef, EventEmitter, HostListener, Output, Renderer2} from '@angular/core';
import {element} from 'protractor';

@Directive({
    selector: '[appNavPosition]'
})
export class NavPositionDirective {

    constructor(el?: ElementRef, private renderer?: Renderer2) {
        const navPosition = localStorage.getItem('appNavPosition');
        if (navPosition && (navPosition === 'left' || navPosition === 'right' || navPosition === 'bottom')) {
            this.renderer.setAttribute(el.nativeElement, 'class', navPosition);
        } else {
            this.renderer.setAttribute(el.nativeElement, 'class', 'left');
            localStorage.setItem('appNavPosition', 'left');
        }

    }

}

@Directive({
    selector: '[appCompensationSafeArea]'
})
export class NavCompensationSafeAreaDirective {

    shortening = '173px';
    constructor(private el?: ElementRef, private renderer?: Renderer2) {
        this.setTabBarHeight();
    }

    setTabBarHeight() {
        setTimeout(() => {
            const elementClassList: any = this.el.nativeElement.classList;
            console.log('##### elementClassList.value #####--->: ', elementClassList.value);
            if (elementClassList.value.includes('adjust-height')) {
                this.shortening = '10px';
                const regisafeSafeAreaTop = getComputedStyle(document.documentElement).getPropertyValue('--regisafeSafeAreaT');
                this.renderer.setStyle(this.el.nativeElement, 'height', 'calc(100% - (' + this.shortening + ' + ' + regisafeSafeAreaTop + '))');

            } else {
                this.shortening = '173px';
                const regisafeSafeAreaTop = getComputedStyle(document.documentElement).getPropertyValue('--regisafeSafeAreaT');
                this.renderer.setStyle(this.el.nativeElement, 'height', 'calc(100% - (' + this.shortening + ' + ' + regisafeSafeAreaTop + '))');
            }

            const regisafeSafeAreaBottom = getComputedStyle(document.documentElement).getPropertyValue('--regisafeSafeAreaB');
            if (regisafeSafeAreaBottom !== '0px') {
                this.renderer.setStyle(this.el.nativeElement, 'padding-bottom', '0px');
                this.renderer.setStyle(this.el.nativeElement, 'padding-left', '0px');
            }

        }, 250);

    }

    @HostListener('click', ['$event'])
    public onListenerTriggered(event: any): void {
        this.setTabBarHeight();
    }
}

@Directive({
    selector: '[appRegisafeTabBar]'
})
export class TabBarHeightDirective {



}
